import contactListTemplate from './contactList.html';
import contactListFilterModalTemplate from './contactListFilterModal.html';
import campaignSelectModalTemplate from './campaignSelectModal.html';

const contactFilterModal = {
    bindings: {
        onSearch: '=',
        onSort: '=',
        openModal: '=',
        showCheckboxes: '=?',
        contacts: '=',
        customContacts: '=',
        selectCampaign: '=',
        assignContacts: '=',
        cancelContactAssignment: '=',
        contactsCount: '=',
        customContactsCount: '=',
        contactType: '=',
        searchText: '=',
        filterIndicationText: '=?',
        callingPage: '=?',
        updateDisable: '=',
        onExport: '=',
        onSaveSearch: '=',
        savedSearchList: '=',
        onSaveApply: '=',
        onSaveDelete: '=',
    },

    template: contactListTemplate,

    controller: function (
        $scope,
        $state,
        $stateParams,
        $ionicLoading,
        $ionicModal,
        ApiContacts,
        ApiInvestors,
        ApiSelections,
        ApiUser,
        ApiCampaigns,
        MessageBox,
        filterHistory,
        $filter,
        $rootScope,
        FileSaver,
        sentEmailPopup
    ) {
        ApiUser.getUser().then((user) => {
            this.user = user;
        });

        this.FileSaver = FileSaver;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.package = [];
        this.investorSubtypes = [];
        this.modal = $ionicModal.fromTemplate(contactListFilterModalTemplate, {
            scope: $scope,
        });
        this.campaignSelectModal = $ionicModal.fromTemplate(
            campaignSelectModalTemplate,
            { scope: $scope }
        );
        this.campaignId = '';
        this.loading = [];
        this.MessageBox = MessageBox;
        this.ApiContacts = ApiContacts;
        this.ApiInvestors = ApiInvestors;
        this.filterHistory = filterHistory;

        this.filterParameter = { investorSubtypes: [] };
        this.filterParameterObj = {
            customerContactType: undefined,
            investorSubtypes: [],
            selectionId: undefined,
            searchText: undefined,
            firstQueryResult: undefined,
            sortOrder: 'AUM',
            sortDirection: 'DESC',
        };
        this.contactsMoreData = false;
        this.customContactsMoreData = false;
        this.loadingContacts = true;
        this.loadingCustomContacts = true;

        var self = this;
        $rootScope.$on(
            '$stateChangeStart',
            function (event, toState, toParams, fromState, fromParam) {
                if (self.closeModal() != null) self.closeModal();
            }
        );

        this.$onInit = () => {
            this.campaignId = this.$stateParams.campaignId;
            if (this.campaignId) {
                this.showCheckboxes = true;
            }

            this.showLoading();

            this.preLoadFilter();

            // Investor Package (selections)
            ApiSelections.getSelectionsMinimal().then((packages) => {
                this.packageOne = packages || [];
            });

            // Investor Type
            ApiInvestors.getInvestorsSubtypes().then((investorSubtypes) => {
                if (investorSubtypes) {
                    this.investorSubtypes = investorSubtypes.map((subtype) => {
                        return { value: subtype };
                    });
                }
            });

            this.loadPackageContacts();
            if (!this.filterParameter.package) {
                this.loadCustomContacts();
            } else {
                this.customContacts = [];
                this.customContactsMoreData = false;
                this.customContactsCount = 0;
            }
            this.getFilterIndicationText();

            let self = this;
            this.campaignSelectModal.scope.$on('modal.hidden', function (arg) {
                if (!self.campaignId) self.showCheckboxes = false;
            });

            this.assignedContacts = new Set();
            this.assignedCustomContacts = new Set();
        };

        this.loadPackageContacts = () => {
            this.loadingContacts = true;
            this.ApiContacts.getPackageContacts(this.filterParameterObj).then(
                (contacts) => {
                    if (contacts.length < 50) {
                        this.contactsMoreData = false;
                    } else {
                        this.contactsMoreData = true;
                    }

                    this.contacts = contacts || [];
                    this.hideAlreadyAssignedContacts();
                    this.loadingContacts = false;
                    this.hideLoading();
                }
            );

            this.ApiContacts.getContactsCount(this.filterParameterObj).then(
                (response) => {
                    this.contactsCount = response || 0;
                }
            );
        };

        this.loadCustomContacts = () => {
            this.loadingCustomContacts = true;
            this.ApiContacts.getTeamContacts(this.filterParameterObj).then(
                (contacts) => {
                    if (contacts.length < 50) {
                        this.customContactsMoreData = false;
                    } else {
                        this.customContactsMoreData = true;
                    }

                    this.customContacts = contacts || [];
                    this.hideAlreadyAssignedContacts();
                    this.loadingCustomContacts = false;
                }
            );

            this.ApiContacts.getCustomContactsCount(
                this.filterParameterObj
            ).then((response) => {
                this.customContactsCount = response || 0;
            });
        };

        this.getMoreContacts = () => {
            this.loadingContacts = true;
            this.filterParameterObj.firstQueryResult =
                this.contacts && this.contacts.length;
            this.ApiContacts.getPackageContacts(this.filterParameterObj).then(
                (contacts) => {
                    if (!contacts) {
                        this.contactsMoreData = false;
                    } else {
                        this.contactsMoreData =
                            contacts.length < 50 ? false : true;
                        this.contacts = this.contacts.concat(contacts);
                        $scope.$broadcast('scroll.infiniteScrollComplete');
                        this.hideAlreadyAssignedContacts();
                    }
                    this.loadingContacts = false;
                }
            );
        };

        this.getMoreCustomContacts = () => {
            this.loadingCustomContacts = true;
            this.filterParameterObj.firstQueryResult =
                this.customContacts && this.customContacts.length;
            this.ApiContacts.getTeamContacts(this.filterParameterObj).then(
                (contacts) => {
                    if (!contacts) {
                        this.customContactsMoreData = false;
                    } else {
                        this.customContactsMoreData =
                            contacts.length < 50 ? false : true;
                        this.customContacts =
                            this.customContacts.concat(contacts);
                        $scope.$broadcast('scroll.infiniteScrollComplete');
                        this.hideAlreadyAssignedContacts();
                    }
                    this.loadingCustomContacts = false;
                }
            );
        };

        // hide contacts that are already assigned to the selected campaign
        this.hideAlreadyAssignedContacts = () => {
            if (!this.campaignId || !this.showCheckboxes) return;
            ApiCampaigns.getCampaignContacts(this.campaignId).then(
                (campaignContacts) => {
                    let alreadyAssignedContacts = new Set();
                    let alreadyAssignedCustomContacts = new Set();
                    if (campaignContacts) {
                        campaignContacts.forEach((contact) => {
                            if (contact.contactInfo.contact.customer) {
                                alreadyAssignedCustomContacts.add(
                                    contact.contactInfo.contact.id
                                );
                            } else {
                                alreadyAssignedContacts.add(
                                    contact.contactInfo.contact.id
                                );
                            }
                        });
                    }
                    this.contacts.forEach((contactsObj) => {
                        contactsObj.hide = alreadyAssignedContacts.has(
                            contactsObj.contactInfo.contact.id
                        );
                        contactsObj.checked = this.assignedContacts.has(
                            contactsObj.contactInfo.contact.id
                        );
                    });

                    this.customContacts.forEach((customContactsObj) => {
                        customContactsObj.hide =
                            alreadyAssignedCustomContacts.has(
                                customContactsObj.contactInfo.contact.id
                            );
                        customContactsObj.checked =
                            this.assignedCustomContacts.has(
                                customContactsObj.contactInfo.contact.id
                            );
                    });
                }
            );
        };

        this.selectCampaign = () => {
            // Campaigns
            ApiCampaigns.getAllChildCampaigns().then((campaigns) => {
                this.campaigns = campaigns || [];
            });
            this.campaignSelectModal.show();
        };

        this.assignContacts = () => {
            if (!this.campaignId) return;

            var assignPromises = [];

            if (this.assignedContacts.size > 0) {
                assignPromises.push(
                    ApiCampaigns.putCampaignContacts(
                        this.campaignId,
                        this.assignedContacts
                    )
                );
            }

            if (this.assignedCustomContacts.size > 0) {
                assignPromises.push(
                    ApiCampaigns.putCampaignCustomerContacts(
                        this.campaignId,
                        this.assignedCustomContacts
                    )
                );
            }

            Promise.all(assignPromises).then(() => {
                this.showCheckboxes = false;
                this.cancelContactAssignment();
                this.MessageBox.showSuccessMessage('CONTACT', 'ASSIGN');

                /*
                this.$state.go(
                    'campaignDetail',
                    { campaignId: this.campaignId },
                    { reload: true }
                );
                 */
            });
        };

        this.cancelContactAssignment = () => {
            for (let i = 0; i < this.contacts.length; i++) {
                this.contacts[i].hide = false;
            }

            for (let i = 0; i < this.customContacts.length; i++) {
                this.customContacts[i].hide = false;
            }

            //this.assignContacts.clear();
            this.assignedCustomContacts.clear();

            this.redirectBackToCampaignDetailPageOnCancel();
            delete this.campaignId;

            this.ApiContacts.getContactsCount(this.filterParameterObj).then(
                (response) => {
                    this.contactsCount = response || 0;
                }
            );

            this.ApiContacts.getCustomContactsCount(
                this.filterParameterObj
            ).then((response) => {
                this.customContactsCount = response || 0;
            });
        };

        this.redirectBackToCampaignDetailPageOnCancel = () => {
            if (
                this.campaignId &&
                this.campaignId > 0 &&
                this.callingPage == 'campaignDetail'
            ) {
                $state.go('campaignDetail', {
                    campaignId: this.campaignId,
                    sortOrder: null,
                });
            }
        };

        this.deleteContact = (contact, index) => {
            this.showLoading();
            ApiContacts.deleteContact(contact.contactInfo.contact.id).then(
                (res) => {
                    this.hideLoading();
                    if (angular.isUndefined(res)) return;
                    this.customContacts.splice(index, 1);
                    this.customContactsCount--;
                }
            );
        };

        // Show filter modal box
        this.openModal = () => {
            this.investorSubtypes.forEach((subtype) => {
                if (
                    this.filterParameterObj.investorSubtypes.includes(
                        subtype.value
                    )
                ) {
                    subtype.checked = true;
                } else {
                    subtype.checked = false;
                }
            });
            this.filterParameter.investorSubtypes = angular.copy(
                this.investorSubtypes
            );
            this.updateDisable(true);
            var self = this;
            this.modal.scope.$on('modal.hidden', () => {
                self.updateDisable(false);
            });
            this.modal.show();
        };

        // Close filter modal box
        this.closeModal = () => {
            this.modal.hide();
            this.campaignSelectModal.hide();
        };

        this.cancelModal = () => {
            this.filterParameter.investorSubtypes = this.investorSubtypes;
            this.closeModal();
        };

        this.showChildren = (id, parent) => {
            switch (parent) {
                case 'packageOne':
                    this.packageTwo = undefined;
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesTwo) => {
                                this.packageTwo = packagesTwo || [];
                            }
                        );
                    }
                    break;
                case 'packageTwo':
                    this.packageThree = undefined;
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesThree) => {
                                this.packageThree = packagesThree || [];
                            }
                        );
                    }
                    break;
                case 'packageThree':
                    this.packageFour = undefined;
                    if (id) {
                        ApiSelections.getSelectionChildren(id).then(
                            (packagesFour) => {
                                this.packageFour = packagesFour || [];
                            }
                        );
                    }
                    break;
                default:
                    return false;
            }
        };

        // Handle when user clicks filter-go button
        this.onFilter = () => {
            // add selected package to filterParameterObj
            if (this.filterParameter.packageFour) {
                this.filterParameter.package = this.filterParameter.packageFour;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageFour.selectionId;
            } else if (this.filterParameter.packageThree) {
                this.filterParameter.package =
                    this.filterParameter.packageThree;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageThree.selectionId;
            } else if (this.filterParameter.packageTwo) {
                this.filterParameter.package = this.filterParameter.packageTwo;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageTwo.selectionId;
            } else if (this.filterParameter.packageOne) {
                this.filterParameter.package = this.filterParameter.packageOne;
                this.filterParameterObj.selectionId =
                    this.filterParameter.packageOne.selectionId;
            } else {
                this.filterParameter.package = undefined;
                this.filterParameterObj.selectionId = undefined;
            }

            this.populateFilterCriteria();

            this.loadPackageContacts();
            if (!this.filterParameter.package) {
                this.loadCustomContacts();
            } else {
                this.customContacts = [];
                this.customContactsMoreData = false;
                this.customContactsCount = 0;
            }
            this.filterHistory.saveFilter(
                angular.copy(this.filterParameter),
                'contact'
            );
            this.getFilterIndicationText();
            this.closeModal();
        };

        // Remove filter
        this.removeContactType = () => {
            if (this.filterParameter.customerContactType) {
                delete this.filterParameter.customerContactType;
            }
            this.onFilter();
        };

        this.removePackage = () => {
            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }
            this.onFilter();
        };

        this.removeInvestorType = (subtype) => {
            subtype.checked = false;
            this.onFilter();
        };

        this.removeAllFilters = () => {
            if (this.filterParameter.customerContactType) {
                delete this.filterParameter.customerContactType;
            }

            if (this.filterParameter.package) {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }

            this.filterParameter.investorSubtypes.forEach((subtype) => {
                subtype.checked = false;
            });

            this.onFilter();
        };

        this.preLoadFilter = () => {
            let filter = this.filterHistory.readFilter('contact');
            if (filter) {
                this.filterParameter = filter;
                if (this.filterParameter.package) {
                    this.filterParameterObj.selectionId =
                        this.filterParameter.package.selectionId;
                }
                this.populateFilterCriteria();
            }
        };

        this.populateFilterCriteria = () => {
            this.filterParameterObj.investorSubtypes = [];
            this.filterParameter.investorSubtypes.forEach((subtype) => {
                if (subtype.checked) {
                    this.filterParameterObj.investorSubtypes.push(
                        subtype.value
                    );
                }
            });
            this.filterParameterObj.firstQueryResult = undefined;
            this.filterParameterObj.searchText =
                this.filterParameter.searchText;
            if (this.filterParameter.searchText) {
                this.searchText = this.filterParameter.searchText;
            }
        };

        this.reverseFilter = () => {
            this.filterParameter.investorSubtypes = angular.copy(
                this.investorSubtypes
            );

            this.filterParameter.investorSubtypes.forEach((subtype) => {
                subtype.checked =
                    this.filterParameterObj.investorSubtypes.indexOf(
                        subtype.value
                    ) !== -1;
            });

            this.filterParameter.searchText =
                this.filterParameterObj.searchText;
            this.searchText = this.filterParameter.searchText;

            if (
                this.packageFour &&
                this.isPackage(
                    this.packageFour,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageFour,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageFour = this.filterParameter.package;
            } else if (
                this.packageThree &&
                this.isPackage(
                    this.packageThree,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageThree,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageThree =
                    this.filterParameter.package;
            } else if (
                this.packageTwo &&
                this.isPackage(
                    this.packageTwo,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageTwo,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageTwo = this.filterParameter.package;
            } else if (
                this.packageOne &&
                this.isPackage(
                    this.packageOne,
                    this.filterParameterObj.selectionId
                )
            ) {
                this.filterParameter.package = this.isPackage(
                    this.packageOne,
                    this.filterParameterObj.selectionId
                );
                this.filterParameter.packageOne = this.filterParameter.package;
            } else {
                delete this.filterParameter.package;
                delete this.filterParameter.packageOne;
                delete this.filterParameter.packageTwo;
                delete this.filterParameter.packageThree;

                this.filterParameterObj.selectionId = undefined;
            }
        };

        this.isPackage = (packageItem, sectionId) => {
            return packageItem.find((item) => {
                return item.selectionId === sectionId;
            });
        };

        this.showLoading = () => {
            this.loading.push(1);
            $ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>',
            });
        };

        this.hideLoading = () => {
            this.loading.pop();
            if (this.loading.length === 0) $ionicLoading.hide();
        };

        this.onSearch = (search) => {
            this.filterParameter.searchText = search;
            this.onFilter();
        };

        this.onSort = (field, order) => {
            this.filterParameterObj.sortDirection = order;
            this.filterParameterObj.sortOrder = field;
            this.onFilter();
        };

        this.getFilterIndicationText = () => {
            let filter = this.filterParameter;
            let text = '';
            if (!filter) return '';
            let investorExists = filter.investorSubtypes.some((i) => {
                return i.checked;
            });
            if (this.filterParameter.packageOne)
                text = text + $filter('translate')('PACKAGE') + ', ';
            if (investorExists)
                text = text + $filter('translate')('INVESTOR_TYPES') + ', ';
            if (text.length > 0) {
                text = 'Filter by: ' + text.substring(text.length - 2, 0);
            }
            this.filterIndicationText = text;
        };

        this.deleteItem = (contact, position) => {
            this.deleteContact(contact, position);
        };

        this.emailContacts = () => {
            $ionicLoading.show();
            this.ApiContacts.emailContacts(this.filterParameterObj).then(
                (data) => {
                    $ionicLoading.hide();
                    this.MessageBox.showSuccessMessage(
                        'EXPORT_CONTACT',
                        'SENT'
                    );
                }
            );
        };

        this.onExport = () => {
            sentEmailPopup.show(
                `${this.user.firstName} ${this.user.name}`,
                this.emailContacts
            );
        };

        this.onSaveSearch = (name) => {
            this.ApiContacts.postSavedSearch({
                filter: this.filterParameterObj,
                filterName: name,
            }).then((data) => {
                if (data) {
                    this.MessageBox.showSuccessMessage('SEARCH', 'SAVED');
                }
            });
        };

        this.savedSearchList = () => {
            return this.ApiContacts.getSavedSearch();
        };

        this.onSaveApply = (filter) => {
            this.filterParameterObj = angular.copy(filter);
            this.reverseFilter();
            this.onFilter();
        };

        this.onSaveDelete = (name) => {
            this.ApiContacts.deleteSavedSearch(name);
            // this.MessageBox.showSuccessMessage('SEARCH', 'DELETED');
        };
    },
};

export default contactFilterModal;



/** WEBPACK FOOTER **
 ** ./src/app/directives/contactList/contactList.js
 **/